import React from 'react';
import PropTypes from 'prop-types';
import { Form, H4, P, Icon } from '@contently/toolkit';
import styled from '@emotion/styled';

import useLocalStorage from '../utils/hooks/useLocalStorage';
import CallToAction from './CallToAction';

const StyledCallToActionCard = styled('div')`
  padding: 3em;
  width: 27.625em;
  height: 20em;
  box-sizing: border-box;
  background: white;
  box-shadow: 0 2px 6px 0 #f6f6f6, inset 0 0 1px 0 #e5e5e5;
  border-radius: 0 0 3px 3px;
  position: relative;
  ${P} {
    font-size: 0.875em;
    line-height: 1.5;
    font-weight: 300;
    padding: 0.5em 0;
  }
  ${Form.Button} {
    border: 0;
    text-transform: none;
    background: #e8f7fa;
    ${Icon} {
      font-size: 1.25rem;
      margin-left: 0.5em;
    }
  }
`;

const CallToActionCard = ({ remainingSearches, toggleModal }) => {
  const [totalSearches] = useLocalStorage('totalSearches', 5);

  let CTA = (
    <P>
      <CallToAction />
    </P>
  );

  if (totalSearches === 5 && remainingSearches <= 0) {
    CTA = (
      <>
        <P>
          Tell us a bit more about your content needs and we’ll let you search our database three
          more times!
        </P>
        <Form.Button onClick={toggleModal} variant="secondary">
          Let me search again
          <Icon type="angle-right" />
        </Form.Button>
      </>
    );
  }

  return (
    <StyledCallToActionCard key="cta-card">
      <H4>140,000+ additional freelance creators await you in our network.</H4>
      {CTA}
    </StyledCallToActionCard>
  );
};

CallToActionCard.propTypes = {
  toggleModal: PropTypes.func.isRequired,
  remainingSearches: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired
};

export default CallToActionCard;
